<template>
  <b-container fluid>
    <b-row class="mb-3"
           align-v="center"
           align-h="around"
           cols-xl="2"
           cols="1">
      <template v-for="(item, index) in contents.slice(0, 2)">
        <b-col class="column"
               :key="item.type + index">
          <img :src="item.imageUrl"
               alt="chart"/>
        </b-col>
      </template>
    </b-row>
    <!-- Second row with a single column for the last item -->
    <b-row class="mb-3"
           align-v="center"
           align-h="around"
           cols="1">
      <b-col class="column"
             v-if="contents[2].content.length > 0">
        <survey-tendency-comparison-table :slide="slide"
                                          :items="contents[2].content"/>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import SurveyTable from "@/components/survey/SurveyTable.vue";
import SurveyTendencyComparisonTable from "@/components/survey/SurveyTendencyComparisonTable.vue";

export default {
  components: { SurveyTable, SurveyTendencyComparisonTable },
  props: ['slide'],
  computed: {
    contents() {
      return this.slide.content;
    }
  }
}
</script>

<style scoped>
img {
    width: 100%;
}
</style>